<template>
  <el-dialog
    :visible.sync="dialogFormVisible"
    :close-on-click-modal="false"
    @close="dialogClose"
    custom-class="custom_dialog batch_add_dialog"
    top="20px"
  >
    <el-tabs v-model="activeName">
      <el-tab-pane label="题库批量添加" name="first">
        <div class="wj_search_main" :style="formBodyStyle">
          <div class="wj_search_left">
            <el-input
              placeholder="请输入检索内容"
              v-model="groupListQuery.KeyWord"
              clearable
              style="width: 180px"
            >
            </el-input>
            <el-button @click="getQuestionGroups()">查询</el-button>
            <el-table
              ref="questionGroupTable"
              :data="questionGroupList"
              highlight-current-row
              @current-change="handleSelectCurrentChange"
              style="width: 100%"
              :max-height="groupTableyHeight"
            >
              <el-table-column label="题目分类">
                <template slot-scope="scope">
                  <i class="iconfont icon-bg-list"></i>
                  {{ scope.row.Name }}
                </template>
              </el-table-column>
            </el-table>
            <div class="pagination_box">
              <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[10, 20, 30, 50]"
                :page-size="groupListQuery.MaxResultCount"
                :layout="pagination_layout"
                :total="groupListTotalCount"
              >
              </el-pagination>
            </div>
          </div>
          <div class="wj_search_right">
            <el-table
              ref="questionTable"
              :data="questionList"
              stripe
              @selection-change="handleSelectionChange"
              @cell-mouse-leave="leaveCall"
              @row-click="selectRowChange"
              v-loading="questionTableLoading"
              :max-height="questionTableyHeight"
              style="width: 99%"
            >
              <el-table-column label="请选择题目">
                <template slot-scope="scope">
                  <div class="div_element_title_all">
                    <span class="show_index">{{ scope.$index + 1 }}.</span>
                    <div class="div_element_title">
                      <div v-html="scope.row.QuestionStem"></div>
                      <span class="element_type">
                        （{{ scope.row.QuestionTypeText }}）
                      </span>
                      <span class="element_score">
                        （{{ scope.row.Score }}分）
                      </span>
                    </div>
                  </div>
                  <div
                    class="div_element_option_box"
                    v-if="scope.row.QuestionType !== 4"
                  >
                    <div
                      class="div_element_option_item"
                      v-for="(optionItem, optionIndex) in scope.row.OptionItems"
                      :key="optionIndex"
                    >
                      <i
                        class="
                          iconfont
                          icon-duoxuan-yixuanze
                          div_element_option_item_right
                        "
                        v-if="optionItem.IsRight"
                      ></i>
                      <i
                        class="iconfont icon-32duoxuanweixuanzhong"
                        v-if="!optionItem.IsRight"
                      ></i>
                      <span class="div_element_option_item_index">
                        {{ String.fromCharCode(65 + optionIndex) + '、' }}
                      </span>
                      <div v-html="optionItem.Content"></div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                type="selection"
                width="55"
                className="v_align_top"
              >
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>

    <div slot="footer" class="dialog-footer">
      <span>
        已选
        <b>{{ selectRows.length }}</b>
        个题目
      </span>
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="batchAdd()"> 确 定 </el-button>
    </div>
  </el-dialog>
</template>

<script>
import questionGroupApi from '../../api/wj/questionGroup.js'
import questionApi from '../../api/wj/question.js'
export default {
  name: 'BatchAdd',
  components: {
  },
  data () {
    return {
      dialogFormVisible: false,
      formBodyStyle: { height: (window.innerHeight - 230) + 'px' },
      groupTableyHeight: window.innerHeight - 310,
      questionTableyHeight: window.innerHeight - 230,
      activeName: 'first',
      groupListQuery: {
        meetingId: null,
        companyId: null,
        maxResultCount: 10,
        skipCount: 0,
        KeyWord: null,
        Sorting: 'CreationTime desc,Sort'
      },
      questionGroupList: [],
      groupListTotalCount: 0,
      currentPage: 1,
      pagination_layout: 'prev, pager, next',
      questionList: [],
      questionListTotalCount: 0,
      questionListQuery: {
        GroupId: null,
        maxResultCount: 999999,
        skipCount: 0
      },
      questionTableLoading: false,
      selectRows: [],
      itemIndex: 0,
      newElements: [],
      selectGroups: []
    }
  },
  props: {
    fatherSubmitDialog: {
      type: Function,
      default: null
    }
  },
  methods: {
    openBatchAdd: function (index, companyId) {
      this.dialogFormVisible = true
      this.itemIndex = index
      this.groupListQuery.companyId = companyId
      this.getQuestionGroups()
    },
    batchAdd: function () {
      const _this = this
      _this.newElements = []
      _this.selectRows.forEach(function (selectRow, index) {
        const elementItem = {
          Id: null,
          QuestionnaireId: _this.$route.params.qid,
          ElementType: 2,
          Title: null,
          RandomCondition: null,
          RandomQuestionGroups: [],
          QuestionId: selectRow.Id,
          QuestionType: selectRow.QuestionType,
          QuestionStem: selectRow.QuestionStem,
          Score: selectRow.Score,
          TextHeight: selectRow.TextHeight,
          TextWidth: selectRow.TextWidth,
          MinWordNum: selectRow.MinWordNum,
          MaxWordNum: selectRow.MaxWordNum,
          TextValidation: selectRow.TextValidation,
          OptionItems: []
        }
        selectRow.OptionItems.forEach(function (selectRowOptionItem, index) {
          const optionItem = {
            Id: null,
            Content: selectRowOptionItem.Content,
            IsRight: selectRowOptionItem.IsRight,
            TextHeight: selectRowOptionItem.TextHeight,
            TextWidth: selectRowOptionItem.TextWidth,
            MinWordNum: selectRowOptionItem.MinWordNum,
            MaxWordNum: selectRowOptionItem.MaxWordNum,
            TextValidation: selectRowOptionItem.TextValidation,
            RightAnswers: selectRowOptionItem.RightAnswers
          }
          elementItem.OptionItems.push(optionItem)
        })
        _this.newElements.push(elementItem)
      })
      _this.fatherSubmitDialog(_this.newElements, _this.itemIndex)
      _this.dialogFormVisible = false
    },
    dialogClose: function (done) {
    },
    getQuestionGroups: function () {
      const openLoading = this.openLoading()
      questionGroupApi.getQuestionGroups(this.groupListQuery).then(data => {
        this.questionGroupList = data.Items
        this.groupListTotalCount = data.TotalCount
        this.$refs.questionGroupTable.setCurrentRow(this.questionGroupList[0])
        openLoading.close()
      }).catch(err => {
        openLoading.close()
        return err
      })
    },
    handleSizeChange (val) {
      this.groupListQuery.maxResultCount = val
      this.getQuestionGroups()
    },
    handleCurrentChange (val) {
      this.groupListQuery.skipCount = (val - 1) * this.groupListQuery.maxResultCount
      this.getQuestionGroups()
    },
    handleSelectCurrentChange (val) {
      this.questionListQuery.GroupId = val.Id
      this.getQuestions()
    },
    getQuestions: function () {
      this.questionTableLoading = true
      questionApi.getQuestions(this.questionListQuery).then(data => {
        this.questionList = data.Items
        this.questionListTotalCount = data.TotalCount
        this.questionTableLoading = false
      }).catch(err => {
        this.questionTableLoading = false
        return err
      })
    },
    handleSelectionChange: function (val) {
      this.selectRows = val
      //   this.selectGroups.forEach(function (selectGroup, index) {
      //     if (selectGroup.groupId.toLowerCase() === this.questionListQuery.GroupId.toLowerCase()) {

      //     }
      //   })
    },
    leaveCall: function (row, column, cell, event) {
      if (event.which === 1) {
        this.$refs.questionTable.toggleRowSelection(row)
      }
    },
    selectRowChange: function (row, column, event) {
      this.$refs.questionTable.toggleRowSelection(row)
    }
  },
  created () {

  }
}
</script>
<style lang="less">
.batch_add_dialog .el-dialog__body {
  border-bottom: 1px solid #e8e8e8;
  padding: 0px 10px;
}
.batch_add_dialog .el-dialog__header {
  padding: 10px;
}
.batch_add_dialog .el-dialog__headerbtn {
  top: 8px;
  right: 8px;
}
.wj_search_main {
  padding: 0px;
  width: 100%;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: flex-start;
}
.wj_search_left {
  flex-shrink: 0;
  width: 270px;
  height: 100%;
  border-right: 2px solid #e8e8e8;
}
.wj_search_left .search {
  padding: 0px 20px 0px 0px;
  box-sizing: border-box;
}
.wj_search_right {
  flex-grow: 1;
  height: 100%;
}
</style>
